import React from "react"

export const FundAllocationContext = React.createContext()